import React from "react";
import PayTypesSection from "./PayTypesSection";

// The set of upfront pay types a company admin can build options from. Each
// entry carries a human-readable label, a plain-language description of how the
// type pays out, and the default legal document text used when the type is
// referenced in a rep's agreement.
const UPFRONT_PAY_TYPES = [
  {
    value: "FIXED_AMOUNT_PER_ACCOUNT",
    label: "Fixed Amount Per Account",
    description:
      "A fixed dollar amount is paid upfront for each account sold. The payout is the same per account regardless of how many accounts are sold.",
    documentText:
      "The Representative shall receive a fixed upfront payment for each account sold, in the amount specified for this pay option, payable per qualifying account.",
  },
  {
    value: "SCALE_AMOUNT_PER_ACCOUNT",
    label: "Scaled Amount Per Account",
    description:
      "A per-account dollar amount that varies based on the number of accounts sold. As the rep crosses each account tier, the per-account amount changes according to the configured scale.",
    documentText:
      "The Representative shall receive an upfront payment for each account sold, with the per-account amount determined by the applicable tier of the scale based on the total number of qualifying accounts sold.",
  },
  {
    value: "SCALE_AMOUNT_TOTAL",
    label: "Scaled Amount Total",
    description:
      "A total dollar amount that varies based on the number of accounts sold. The configured scale determines a single total payout for the deal rather than a per-account amount.",
    documentText:
      "The Representative shall receive a total upfront payment determined by the applicable tier of the scale, based on the total number of qualifying accounts sold.",
  },
  {
    value: "FIXED_PERCENT_ACV",
    label: "Fixed Percentage of ACV (Annual Contract Value)",
    description:
      "A fixed percentage of the Annual Contract Value (ACV) is paid upfront. The same percentage applies regardless of the number of accounts or contract size.",
    documentText:
      "The Representative shall receive an upfront payment equal to the fixed percentage specified for this pay option, applied to the Annual Contract Value (ACV) of each qualifying account.",
  },
  {
    value: "INITIAL_PRICE",
    label: "Initial Price",
    description:
      "Upfront pay is based on the initial price of the account or contract at the time of sale.",
    documentText:
      "The Representative shall receive an upfront payment based on the initial price of each qualifying account or contract as recorded at the time of sale.",
  },
  {
    value: "SCALE_PERCENT_ACV",
    label: "Scaled Percentage of ACV (Annual Contract Value)",
    description:
      "A percentage of the Annual Contract Value (ACV) that varies based on the number of accounts sold. The configured scale determines which percentage applies as the rep crosses each account tier.",
    documentText:
      "The Representative shall receive an upfront payment equal to a percentage of the Annual Contract Value (ACV) of each qualifying account, with the applicable percentage determined by the tier of the scale based on the total number of qualifying accounts sold.",
  },
];

function UpfrontPayTypesList({ companyTypes, onTypesChange }) {
  return (
    <PayTypesSection
      intro="The following upfront pay types are available when configuring upfront pay options."
      types={UPFRONT_PAY_TYPES}
      companyTypes={companyTypes}
      endpoint="upfront"
      onTypesChange={onTypesChange}
    />
  );
}

export default UpfrontPayTypesList;
